import { render, staticRenderFns } from "./IngresoCorreo.vue?vue&type=template&id=4861eea1"
import script from "./IngresoCorreo.vue?vue&type=script&lang=js"
export * from "./IngresoCorreo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports